/**
 * Transforms backend news data into a simplified list format for frontend use.
 * @param {object} backendData - The raw data object received from the backend.
 * @param {Array} backendData.items - An array of news items to be processed.
 * @param {object} backendData.items[].id - The unique identifier of the news item.
 * @param {object} backendData.items[].title - The title of the news item.
 * @param {object} backendData.items[].previewImageUrl - The URL of the preview image for the news item.
 * @param {object} backendData.items[].publishedAt - The publication date of the news item.
 * @returns {Array<object>} A formatted array of news items, each containing:
 *   - {string} id - News item ID (empty string if missing).
 *   - {string} title - News item title (empty string if missing).
 *   - {string|null} image - Preview image URL or null if unavailable.
 *   - {string} date - Publication date (empty string if missing).
 */
export function prepareLastNewsList(backendData) {
  if (!backendData || !Array.isArray(backendData)) {
    return [];
  }

  return backendData.map((item) => {
    return {
      id: item?.id || '',
      slug: item?.slug || '',
      title: item?.title || '',
      image: item?.previewImageUrl || null,
      date: item?.publishedAt || '',
    };
  });
}
